import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Metric from "../Metric";
import TrafficLightBar from "../TrafficLightBar";
import { getThresholdsColorForValue } from "../../lib/thresholds";
import style from "./style.module.scss";
export default function TrafficBudget(props) {
    const { series, type } = props;
    if (typeof series === "undefined") {
        return null;
    }
    let value = 0;
    if (typeof series.stat !== "undefined") {
        value = series.stat;
    }
    let isInverted = false;
    if (typeof series.isInverted !== "undefined") {
        isInverted = series.isInverted;
    }
    const suffix = series.suffix ? series.suffix : "";
    const thresholds = series.thresholds ? series.thresholds : [];
    // increase layout/percentage min when we have long decimals like CLS
    const percentage_min = series.metricType === "score_decimal" ? 10 : 5;
    // get thresholds from the series
    const thresholdWarning = thresholds[0].value;
    const thresholdBad = thresholds[1].value;
    const color = getThresholdsColorForValue(thresholds, value);
    let state = "good";
    if (value > thresholdBad) {
        state = "bad";
    }
    else if (value > thresholdWarning) {
        state = "warning";
    }
    if (isInverted) {
        state = "good";
        if (value < thresholdWarning) {
            // use warning even though it's "bad" as we select threshold based on order
            state = "bad";
        }
        else if (value < thresholdBad) {
            state = "warning";
        }
    }
    // even though we show the traffic light as 1/3 the thresholds might not be in thirds
    // base the max width on the distance between thresholds
    const maxWidth = thresholdBad + (thresholdBad - thresholdWarning);
    // work out which third we're in first
    let percentage = 50;
    if (value >= maxWidth) {
        percentage = 100;
    }
    else if (value >= thresholdBad) {
        const chunk = maxWidth - thresholdBad;
        const chunk_value = value - thresholdBad;
        const chunk_percent = chunk_value / chunk;
        percentage = 66 + 33 * chunk_percent;
    }
    else if (value >= thresholdWarning) {
        const chunk = thresholdBad - thresholdWarning;
        const chunk_value = value - thresholdWarning;
        const chunk_percent = chunk_value / chunk;
        percentage = 33 + 33 * chunk_percent;
    }
    else if (value < thresholdWarning) {
        const chunk_percent = value / thresholdWarning;
        percentage = 33 * chunk_percent;
    }
    let margin = { marginLeft: percentage + "%" };
    let offset = { transform: "translateX(-50%)", justifySelf: "" };
    // make sure the arrow doesn't poke out over the rounded end
    if (percentage < percentage_min) {
        margin = { marginLeft: "0" };
        offset = { transform: "", justifySelf: "" };
    }
    else if (percentage > 95) {
        margin = { marginLeft: "0" };
        offset = { transform: "", justifySelf: "end" };
    }
    let trafficLightSegments = [
        { id: "good", value: 1, color: "var(--good-color)" },
        { id: "warning", value: 1, color: "var(--warning-color)" },
        { id: "bad", value: 1, color: "var(--bad-color)" },
    ];
    if (isInverted) {
        trafficLightSegments = [
            { id: "bad", value: 1, color: "var(--bad-color)" },
            { id: "warning", value: 1, color: "var(--warning-color)" },
            { id: "good", value: 1, color: "var(--good-color)" },
        ];
    }
    let typeClass = "";
    if (type) {
        // return the smaller mini version
        typeClass = type;
        return (_jsxs("div", { className: classNames(style["traffic-budget"], style["traffic-budget--" + typeClass]), children: [_jsx("div", { className: classNames(style["traffic-budget__metric"]), style: { color: color }, children: value + suffix }), _jsxs("div", { className: style["traffic-budget__bar"], children: [_jsx("div", { className: classNames(style["traffic-budget__metric-arrow"]), style: margin, children: _jsx("div", { className: classNames(style["traffic-budget__arrow"], style["traffic-budget__arrow-" + state]), style: offset }) }), _jsx(TrafficLightBar, { trafficLightSegments: trafficLightSegments })] })] }));
    }
    return (_jsxs("div", { className: classNames(style["traffic-budget"], style["traffic-budget--" + typeClass], "qa-traffic-budget"), children: [_jsxs("div", { className: classNames(style["traffic-budget__metric-arrow"]), style: margin, children: [_jsx("div", { className: classNames(style["traffic-budget__metric"]), style: offset, children: _jsx(Metric, { title: "", value: value + suffix, color: color }) }), _jsx("div", { className: classNames(style["traffic-budget__arrow"], style["traffic-budget__arrow-" + state]), style: offset })] }), _jsx(TrafficLightBar, { trafficLightSegments: trafficLightSegments }), _jsxs("div", { className: classNames(style["traffic-budget__labels"]), children: [_jsxs("div", { className: classNames(style["traffic-budget__label-warning"]), children: [thresholdWarning, suffix] }), _jsxs("div", { className: classNames(style["traffic-budget__label-bad"]), children: [thresholdBad, suffix] })] })] }));
}
